import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ALLOWED_ROLES = ['admin'];

const AdminRoute = ({ children }) => {
  const { userProfile, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100dvh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!userProfile || !ALLOWED_ROLES.includes(userProfile.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
